<template>
  <div id="start-eligibility-tool" class="eligibility-tool">
    <button
      v-show="!isOpen"
      id="contextual-offers-launch-button"
      class="button bg-bright-red eligibility-tool__button eligibility-tool__button--primary eligibility-tool__launch-button"
      type="button"
      @click="open"
    >
      Start check
    </button>

    <EligibilityModal v-if="isOpen" @close="close">
      <TitleScreen v-if="currentStep === 'T1'" @start="start" />
      <OutcomeScreen v-else-if="isOutcome" :outcome-id="currentStep" @back="back" @restart="restart" />
      <LookupQuestion v-else-if="currentStep === 'Q4' || currentStep === 'Q5'" :step-id="currentStep" @back="back" @continue="continueFromLookup" />
      <RadioQuestion v-else :question="question" @back="back" @answer="answer" />
    </EligibilityModal>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { questions } from './utils/decisionTree';
import EligibilityModal from './components/eligibility/EligibilityModal.vue';
import TitleScreen from './components/eligibility/TitleScreen.vue';
import RadioQuestion from './components/eligibility/RadioQuestion.vue';
import LookupQuestion from './components/eligibility/LookupQuestion.vue';
import OutcomeScreen from './components/eligibility/OutcomeScreen.vue';

export default {
  name: 'App',
  components: { EligibilityModal, TitleScreen, RadioQuestion, LookupQuestion, OutcomeScreen },
  computed: {
    ...mapState(['isOpen', 'currentStep']),
    question() {
      return questions[this.currentStep];
    },
    isOutcome() {
      return this.currentStep && this.currentStep.charAt(0) === 'O';
    }
  },
  methods: {
    ...mapActions(['start', 'answer', 'back', 'continueFromLookup']),
    ...mapMutations(['setModalOpen', 'setCurrentStep']),
    open() {
      this.setCurrentStep('T1');
      this.setModalOpen(true);
    },
    restart() {
      this.setCurrentStep('T1');
      this.setModalOpen(true);
    },
    close() {
      this.setModalOpen(false);
    }
  }
};
</script>
